import PropTypes from "prop-types"
import React from "react"
import { useMarina } from "src/contexts/MarinaContext"
import { getPaymentStatusBadgeProps } from "src/main/Billing/Payments/PaymentStatusBadge"

import Badge from "src/components/Badge"
import DataTableV2 from "src/components/DataTableV2"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const PaymentsDataTable = ({
  table,
  onManage,
  onSettle,
  onMerge,
  canManage = true,
}) => {
  const { presentmentCurrency } = useMarina()

  const columns = [
    {
      key: "status",
      header: "Status",
      render: (r) => {
        const { label, color } = getPaymentStatusBadgeProps(r.displayStatus)
        return <Badge text={label} color={color} />
      },
    },
    {
      key: "method",
      header: "Method",
      render: (r) => (r.paymentMethod ? r.paymentMethod.title : "Manual"),
    },
    {
      key: "dueDate",
      header: "Due Date",
      sortable: true,
      render: (r) => r.dueDateFormatted || "-",
    },
    {
      key: "settledDate",
      header: "Settled Date",
      render: (r) => r.settledAtFormatted || "-",
    },
    {
      key: "amount",
      header: "Amount",
      sortable: true,
      sortKey: "totalAmount",
      render: (r) =>
        formatCurrencyFromMinorUnits({
          amount: r.totalAmount,
          currency: presentmentCurrency,
        }),
    },
  ]

  const actions = [
    {
      role: "view",
      label: "Manage",
      icon: "edit-square-md",
      onClickSingle: (r) => onManage(r),
    },
    {
      label: "Settle",
      icon: "pos-cash text-sm",
      primary: true,
      onClickSingle: (r) => onSettle(r),
      hidden: (r) => r.isSettled || !canManage,
    },
    {
      label: "View receipt",
      icon: "receipt",
      href: (r) => r.viewPath,
      hidden: (r) => !r.isSettled,
    },
    {
      label: "View invoice",
      icon: "invoice",
      href: (r) => r.viewPath,
      hidden: (r) => r.isSettled,
    },
    {
      label: "Merge invoices",
      icon: "merge",
      onClickSingle: (r) => onMerge(r),
      hidden: (r) => !r.isMergeable || !canManage,
    },
  ]

  return (
    <DataTableV2
      name="work-order-payments-table"
      columns={columns}
      data={table.records}
      actions={actions}
      maxHeight="none"
      rowConfig={{ onClick: (r) => onManage(r) }}
      emptyState={<span className="text-gray-500">No payments yet</span>}
      {...table.tableProps}
    />
  )
}

PaymentsDataTable.propTypes = {
  table: PropTypes.shape({
    records: PropTypes.array,
    tableProps: PropTypes.object,
  }).isRequired,
  onManage: PropTypes.func.isRequired,
  onSettle: PropTypes.func.isRequired,
  onMerge: PropTypes.func.isRequired,
  canManage: PropTypes.bool,
}

export default PaymentsDataTable
